import { LocationDescriptorObject, LocationDescriptor as To } from "history";

import {
    type HistoryLocationState,
    type HistoryWithState,
    type NavigationType,
    type RouteNavigateFunction,
} from "@/mk2/services/browserHistory";

export function useNavigateBackport(history: HistoryWithState): RouteNavigateFunction {
    return (
        to: string | { pathname?: string; search?: string; hash?: string },
        options?: {
            replace?: boolean;
            state?: HistoryLocationState;
        },
    ) => {
        if (typeof to == "number" && (to as number) < 0) {
            history.go(to as number);
            return;
        }

        const dest: To = {
            pathname: "",
            search: "",
            hash: "",
            ...(typeof to === "string" ? parsePathBackport(to) : { ...to }),
            state: options?.state,
        };
        if (options?.replace) {
            history.replace(dest);
        } else {
            history.push(dest);
        }
    };
}

export function useNavigationTypeBackport(history: HistoryWithState): NavigationType {
    return history.action as NavigationType;
}

export function createPathBackport({
    pathname = "/",
    search = "",
    hash = "",
}: Partial<LocationDescriptorObject>): string {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}

export function parsePathBackport(path: string): Partial<LocationDescriptorObject> {
    const parsedPath: Partial<LocationDescriptorObject> = {};

    if (path) {
        const hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }

        const searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }

        if (path) {
            parsedPath.pathname = path;
        }
    }

    return parsedPath;
}
